module.exports = __webpack_public_path__ + "static/media/bindQQ1.51d19315.png";